import React, { useEffect } from "react"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"

import { useDispatch } from "react-redux"
import { eu_consent, put_data, translate } from "redux/actions/main"
import { toggle_modal } from "redux/actions/modal"

import { audio } from "helper/audio"

const PolicyEUMore = (props) => {
  const dispatch = useDispatch()
  const { google_analytics_popup } = props.main.info
  const { google_analytics_consent } = props.main
  const { policyeumore } = props.modal
  const t = (key) => dispatch(translate(key))

  const handleConsentChange = (consentType) => {
    if (consentType === "analytics") {
      const isChecked = document.getElementById("consent1").checked
      dispatch(
        put_data("google_analytics_consent", {
          ...google_analytics_consent,
          analytics_storage: isChecked ? 1 : 0,
        })
      )
    } else if (consentType === "ads") {
      const isChecked = document.getElementById("consent2").checked
      dispatch(
        put_data("google_analytics_consent", {
          ...google_analytics_consent,
          ad_storage: isChecked ? 1 : 0,
          ad_user_data: isChecked ? 1 : 0,
          ad_personalization: isChecked ? 1 : 0,
        })
      )
    }
  }

  useEffect(() => {
    if (policyeumore) {
      audio("popup").play()
    }

    // eslint-disable-next-line
  }, [policyeumore])

  return (
    <Modal
      open={policyeumore}
      onClose={() => {
        audio("click").play()
        dispatch(toggle_modal("policyeu", true))
        dispatch(toggle_modal("policyeumore", false))
      }}
      focusTrapped={false}
      center
      showCloseIcon={true}
      closeOnOverlayClick={false}
      classNames={{
        overlay: "overlay overlayeumore",
        modal: "policyeu policyeumore",
      }}
    >
      <div className="title">
        <span>{t("EU_TITLE_PREFER")}</span>
      </div>
      <div className="content">
        <div className="policy-content">
          <div className="consent consent-1">
            <input
              type="checkbox"
              name="consent1"
              id="consent1"
              checked={google_analytics_consent.analytics_storage}
              onChange={() => {
                audio("click").play()
                handleConsentChange("analytics")
              }}
            />
            <label
              htmlFor="consent1"
              dangerouslySetInnerHTML={{
                __html: google_analytics_popup?.storage_choice_text,
              }}
            />
          </div>
          <div className="consent consent-2">
            <input
              type="checkbox"
              name="consent2"
              id="consent2"
              checked={google_analytics_consent.ad_storage}
              onChange={() => {
                audio("click").play()
                handleConsentChange("ads")
              }}
            />
            <label
              htmlFor="consent2"
              dangerouslySetInnerHTML={{
                __html: google_analytics_popup?.ad_choice_text,
              }}
            />
          </div>
        </div>
        <div className="button">
          <div
            className="btn btn-accept"
            onClick={() => {
              audio("click").play()
              dispatch(eu_consent(google_analytics_consent))
            }}
          >
            <span>{t("EU_CONFIRM")}</span>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PolicyEUMore
